import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const dialog: CSSProperties = {
  width: 280,
};

const header: CSSProperties = {
  marginBottom: 15,
};

const textFieldContainer: CSSProperties = {
  margin: "10px 0",
};

const labelInputRoot: CSSProperties = {
  color: greys.slate,
  width: "max-content",
};

export const styles = {
  dialog,
  header,
  textFieldContainer,
  labelInputRoot,
};
